// abacConfig.ts

export interface User {
    partyId?: string;
    partyName?: string;
    roles?: string[];
    permissions?: string[];
    status?: string;
    orgPartyRole?: string;
    orgPartyIds?: string[];
    orgPartyName?: string;
    authorizationToken?: string;
}

export enum PLATFORM_PERMISSIONS {
    PARTYMGR_VIEW = "PARTYMGR_VIEW",
    PARTYMGR_CREATE = "PARTYMGR_CREATE",
    PARTYMGR_UPDATE = "PARTYMGR_UPDATE",
    PARTYMGR_DELETE = "PARTYMGR_DELETE",

    REQUEST_VIEW = "REQUEST_VIEW",
    REQUEST_CREATE = "REQUEST_CREATE",
    REQUEST_UPDATE = "REQUEST_UPDATE",
    REQUEST_DELETE = "REQUEST_DELETE",

    ORDER_VIEW = "ORDER_VIEW",
    ORDER_CREATE = "ORDER_CREATE",
    ORDER_UPDATE = "ORDER_UPDATE",
    ORDER_DELETE = "ORDER_DELETE",

    QUOTE_VIEW = "QUOTE_VIEW",
    QUOTE_CREATE = "QUOTE_CREATE",
    QUOTE_UPDATE = "QUOTE_UPDATE",
    QUOTE_DELETE = "QUOTE_DELETE",
    QUOTES_COMPARE_VIEW = "QUOTES_COMPARE_VIEW",

    RFQ_APPROVAL = "RFQ_APPROVAL",
    QUOTE_APPROVAL = "QUOTE_APPROVAL",

    SECURITYGROUP_CREATE = "SECURITYGROUP_CREATE",
    SECURITYGROUP_UPDATE = "SECURITYGROUP_UPDATE",

    GRN_CREATE = "GRN_CREATE",
    GRN_APPROVAL = "GRN_APPROVAL",
    CONTENT_CREATE = "CONTENT_CREATE",
    CONTENT_UPDATE = "CONTENT_UPDATE",
    CONTENT_DELETE = "CONTENT_DELETE",

    ORDER_THREE_WAY_MATCH_VIEW = "ORDER_THREE_WAY_MATCH_VIEW",
    ORDER_THREE_WAY_MATCH_UPDATE = "ORDER_THREE_WAY_MATCH_UPDATE",
    ORDER_PAYMENT_VIEW = "ORDER_PAYMENT_VIEW",
    ORDER_PAYMENT_UPDATE = "ORDER_PAYMENT_UPDATE",
    ORDER_INVOICE_VIEW = "ORDER_INVOICE_VIEW",
    ORDER_INVOICE_UPDATE = "ORDER_INVOICE_UPDATE",

    REPEAT_ORDER_VIEW = "REPEAT_ORDER_VIEW",
    REPEAT_ORDER_CREATE = "REPEAT_ORDER_CREATE",
    REPEAT_ORDER_UPDATE = "REPEAT_ORDER_UPDATE",
    REPEAT_ORDER_ACCEPT = "REPEAT_ORDER_ACCEPT",

    FACILITY_VIEW = "FACILITY_VIEW",
    FACILITY_CREATE = "FACILITY_CREATE",
    FACILITY_UPDATE = "FACILITY_UPDATE",
    FACILITY_DELETE = "FACILITY_DELETE",
    FACILITY_ADMIN = "FACILITY_ADMIN",

    ITEM_ISSUANCE_APPROVER = "ITEM_ISSUANCE_APPROVER",

    ACCOUNTS_PAYABLE_VIEW = "ACCOUNTS_PAYABLE_VIEW",
    ACCOUNTS_PAYABLE_CREATE = "ACCOUNTS_PAYABLE_CREATE",
    ACCOUNTS_PAYABLE_UPDATE = "ACCOUNTS_PAYABLE_UPDATE",
    ACCOUNTS_PAYABLE_DELETE = "ACCOUNTS_PAYABLE_DELETE",
    ACCOUNTS_PAYABLE_ADMIN = "ACCOUNTS_PAYABLE_ADMIN",

    INVOICE_CREATE = "INVOICE_CREATE",
    INVOICE_UPDATE = "INVOICE_UPDATE",
    INVOICE_DELETE = "INVOICE_DELETE",
    INVOICE_VIEW = "INVOICE_VIEW",
}

export enum PLATFORM_ROLES {
    ADMIN = "ADMIN",
    SUPER_ADMIN = "SUPER_ADMIN",
    SOCIETY_ADMIN = "SOCIETY_ADMIN",
    SOCIETY_MEMBER = "SOCIETY_MEMBER",
    VENDOR_ADMIN = "VENDOR_ADMIN",
    SOCIETY = "SOCIETY",
    VENDOR = "VENDOR",
    FACILITY_MANAGER = "FACILITY_MANAGER",
    DELIVERY_AGENT = "DELIVERY_AGENT",
}

